/* src/app/fitter/pages/fitter-absence-cancel/fitter-absence-cancel.component.scss */
/*# sourceMappingURL=fitter-absence-cancel.component.css.map */
